import React from 'react';
import styled from 'styled-components';

const LegendContainer = styled.div`
    max-width: 700px;
    margin: 2.5rem auto 2rem;
    padding: 0 20px;
    width: 80%;
`;

const LegendLabel = styled.span`
  font-size: 0.875rem;
  display: block;
  margin-bottom: 0.25rem;
`;

const LegendList = styled.ul`
  position: relative;
  width: 100%;
  list-style-type: none;
  &:before {
    height: 15px;
    width: 100%;
    background: -moz-linear-gradient(90deg, #f7f4f9 0%, #e7e1ef 16%, #d4b9da 33%, #c994c7 50%, #df65b0 66%, #e7298a 83%, #ce1256 100%);
    background: -webkit-linear-gradient(90deg, #f7f4f9 0%, #e7e1ef 16%, #d4b9da 33%, #c994c7 50%, #df65b0 66%, #e7298a 83%, #ce1256 100%);
    background: linear-gradient(90deg, #f7f4f9 0%, #e7e1ef 16%, #d4b9da 33%, #c994c7 50%, #df65b0 66%, #e7298a 83%, #ce1256 100%);
    content: '';
    display: block;
  }
  li {
    position: absolute;
    font-size: 0.75rem;
    transform: translateX(-50%);
    margin-top: 0.5rem;
    &:before {
      content: '';
      display: block;
      position: absolute;
      width: 2px;
      height: 1.5rem;
      background-color: white;
      left: 50%;
      transform: translate(-50%, -100%);
    }
    &:nth-child(1) {left: 0%;}
    &:nth-child(2) {left: 16.67%;}
    &:nth-child(3) {left: 33.3%;}
    &:nth-child(4) {left: 50%;}
    &:nth-child(5) {left: 66.67%;}
    &:nth-child(6) {left: 83.33%;}
    &:nth-child(7) {left: 100%;}
  }
`;

const Legend = () => (
  <LegendContainer id="legend" className="bentonsanscond-n4">
    <LegendLabel className="legend__label bentonsanscond-n4">Inches</LegendLabel>
    <LegendList>
      <li>0</li>
      <li>4</li>
      <li>8</li>
      <li>12</li>
      <li>16</li>
      <li>20</li>
      <li>24+</li>
    </LegendList>
  </LegendContainer>
);

export default Legend;